import { createSlice } from "@reduxjs/toolkit";
import {
  getCallHistory,
  addCallHistory,
  updateCallHistory,
  setHistoryDialNumberValidateStatus,
} from "../services/history";

interface HistoryState {
  showLoadingIndicator: boolean;
  status: string;
  historyData: Record<string, unknown>[];
  updatedTicketOrCaseNumber: string | null;
  timestamp: string | null;
  error: string | null;
  historyDialNumberValidateStatus: string | null;
  isLoading?: boolean;
}

const initialState: HistoryState = {
  showLoadingIndicator: false,
  status: "idle",
  historyData: [],
  updatedTicketOrCaseNumber: null,
  timestamp: null,
  error: null,
  historyDialNumberValidateStatus: null,
};

const historySlice = createSlice({
  name: "history",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCallHistory.pending, (state) => {
        state.showLoadingIndicator = true;
        state.status = "pending";
        state.error = null;
        state.historyData = [];
      })
      .addCase(getCallHistory.fulfilled, (state, action) => {
        const payload = action.payload as { data: unknown[] };
        state.status = "success";
        state.historyData = payload.data as Record<string, unknown>[];
        state.showLoadingIndicator = false;
        state.error = null;
      })
      .addCase(getCallHistory.rejected, (state) => {
        state.status = "rejected";
        state.showLoadingIndicator = false;
        state.historyData = [];
      })
      .addCase(addCallHistory.pending, (state) => {
        state.status = "pending";
        state.isLoading = true;
      })
      .addCase(addCallHistory.fulfilled, (state, action) => {
        const payload = action.payload as { data: unknown[] };
        state.status = "added";
        state.isLoading = false;
        state.historyData = payload.data as Record<string, unknown>[];
      })
      .addCase(addCallHistory.rejected, (state) => {
        state.status = "rejected";
        state.isLoading = false;
      })
      .addCase(updateCallHistory.pending, (state) => {
        state.status = "pending";
      })
      .addCase(updateCallHistory.fulfilled, (state, action) => {
        const data = action.payload as {
          timestamp: string;
          updates: Record<string, string>;
        };
        state.timestamp = data.timestamp;
        state.updatedTicketOrCaseNumber = data.updates["Ticket or Case #"];
        state.status = "updated";
      })
      .addCase(updateCallHistory.rejected, (state) => {
        state.status = "rejected";
      })
      .addCase(setHistoryDialNumberValidateStatus, (state, action) => {
        state.historyDialNumberValidateStatus = action.payload;
      });
  },
});

export default historySlice.reducer;
